import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "vote-subject__slogan" }
const _hoisted_2 = {
  key: 1,
  class: "vote-subject__image-wrapper"
}
const _hoisted_3 = { class: "vote-subject__label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_responsive_image = _resolveComponent("responsive-image")!

  return (_openBlock(), _createElementBlock("figure", {
    class: _normalizeClass(["vote-subject", { [`vote-subject--${_ctx.state}`]: _ctx.state }])
  }, [
    _createElementVNode("div", {
      class: "vote-subject__content",
      style: _normalizeStyle(
        _ctx.sponsorship?.bg_color
          ? {
              backgroundColor: _ctx.sponsorship?.bg_color,
              color: _ctx.isContrast(_ctx.sponsorship?.bg_color) ? 'black' : 'white',
            }
          : null
      )
    }, [
      (_ctx.sponsorship)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["vote-subject__sponsorship", {
          'vote-subject__sponsorship--with-slogan':
            _ctx.sponsorship.logo && _ctx.sponsorship.text,
        }])
          }, [
            (_ctx.sponsorship.logo)
              ? (_openBlock(), _createBlock(_component_responsive_image, {
                  key: 0,
                  src: _ctx.sponsorship.logo,
                  class: "vote-subject__logo"
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.sponsorship.text), 1)
          ], 2))
        : _createCommentVNode("", true),
      (_ctx.image)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_responsive_image, {
              class: "vote-subject__image",
              src: _ctx.image
            }, null, 8, ["src"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("figcaption", _hoisted_3, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.state), { class: "vote-subject__label-icon" })),
        _createTextVNode(" " + _toDisplayString(_ctx.name), 1)
      ])
    ], 4),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}